import { createApp } from 'vue';

import { router } from './providers';
import { Quasar, Notify, Dialog, Loading, BottomSheet } from 'quasar';
import { createPinia } from 'pinia';
import i18n from '../../i18n';
import lang from 'quasar/lang/ru.js';
import App from './index.vue';

import '@/app/styles/index.scss';
import '@/app/styles/quasar.scss';
import 'quasar/dist/quasar.sass';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import UiKit from '@/ui-kit';
import { sentryInit } from '@/app/sentry';
import { createSentryPiniaPlugin } from '@sentry/vue';

const pinia = createPinia();
// @ts-ignore
export const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(UiKit)
  .use(i18n)
  .use(Quasar, {
    config: {
      notify: {},
    },
    plugins: { Notify, Dialog, Loading, BottomSheet },
    lang: lang,
  });

const excludedKeys = ['notification', 'outlet'];
pinia.use(
  createSentryPiniaPlugin({
    addBreadcrumbs: false,
    stateTransformer: (state) => {
      const stateCopy = JSON.parse(JSON.stringify(state));
      excludedKeys.forEach((key) => delete stateCopy[key]);
      if (stateCopy.historyPayment) delete stateCopy.historyPayment?.transactions?.list;
      if (stateCopy.authUser) delete stateCopy.authUser?.nptData;
      return stateCopy;
    },
  })
);
sentryInit(app);
